<template>
    <main class="container_instruction_desktop" id="instruction_desktop">
        <!--  section left-->
        <secction class="container_instruction_desktop__section_left">
            <article class="container_instruction_desktop__section_left__article">
                <!-- aside top -->
                <aside class="container_instruction_desktop__section_left__article__aside_top">
                    <div class="container_instruction_desktop__section_left__article__aside_top__div">
                        <img src="@/assets/tir-sportif-scaled.jpg" alt="Instructeur de tir"
                            class="container_instruction_desktop__section_left__article__aside_top__div__img">
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_instruction_desktop__section_left__article__aside_bottom">
                    <div class="container_instruction_desktop__section_left__article__aside_bottom__div_text">
                        <p class="container_instruction_desktop__section_left__article__aside_bottom__div_text__p">
                            Accompagnement et conseil lors du tir.
                            Tir de combat, tir sportif.
                        </p>
                    </div>
                    <div class="container_instruction_desktop__section_left__article__aside_bottom__div_link">
                        <a href="https://fr.wikipedia.org/wiki/wordpress"
                            class="container_instruction_desktop__section_left__article__aside_bottom__div_link__a">
                            <p class="container_instruction_desktop__section_left__article__aside_bottom__div_link__a__p">
                                wikipédia
                            </p>
                        </a>
                    </div>
                </aside>
            </article>
        </secction>
        <!-- ############## -->
        <!-- section middle -->
        <!-- ############## -->
        <secction class="container_instruction_desktop__section_middle">
            <!-- article top -->
            <article class="container_instruction_desktop__section_middle__article_top">
                <aside class="container_instruction_desktop__section_middle__article_top__aside">
                    <!-- div vide -->
                    <div class="container_instruction_desktop__section_middle__article_top__aside__div_vide_1">

                    </div>

                    <!-- div titre -->
                    <div class="container_instruction_desktop__section_middle__article_top__aside__div_titre">
                        <h1 class="container_instruction_desktop__section_middle__article_top__aside__div_titre__h1">
                            Instruction tir
                        </h1>
                    </div>

                    <!-- div vide -->
                    <div class="container_instruction_desktop__section_middle__article_top__aside__div_vide_2">

                    </div>

                </aside>
            </article>
            <!-- ############## -->
            <!-- Article bottom -->
            <!-- ############## -->
            <article class="container_instruction_desktop__section_middle__article_bottom">
                <!-- précédent -->
                <aside class="container_instruction_desktop__section_middle__article_bottom__aside_back">
                    <div class="container_instruction_desktop__section_middle__article_bottom__aside_back__div">
                        <button class="container_instruction_desktop__section_middle__article_bottom__aside_back__div__button">
                            <router-link
                                class="container_instruction_desktop__section_middle__article_bottom__aside_back__div__button__router-link"
                                to="/istc">
                                <div
                                    class="container_instruction_desktop__section_middle__article_bottom__aside_back__div__button__router-link__div_1">

                                </div>
                                <!--  -->
                                <div
                                    class="container_instruction_desktop__section_middle__article_bottom__aside_back__div__button__router-link__div_2">

                                </div>
                            </router-link>
                        </button>
                    </div>
                </aside>
                <!-- suivant -->
                <aside class="container_instruction_desktop__section_middle__article_bottom__aside_next">
                    <div class="container_instruction_desktop__section_middle__article_bottom__aside_next__div">
                        <button class="container_instruction_desktop__section_middle__article_bottom__aside_next__div__button">
                            <router-link
                                class="container_instruction_desktop__section_middle__article_bottom__aside_next__div__button__router-link"
                                to="/defense">
                                <div
                                    class="container_instruction_desktop__section_middle__article_bottom__aside_next__div__button__router-link__div_1">

                                </div>
                                <!--  -->
                                <div
                                    class="container_instruction_desktop__section_middle__article_bottom__aside_next__div__button__router-link__div_2">

                                </div>
                            </router-link>
                        </button>
                    </div>
                </aside>
            </article>
        </secction>
        <!-- ############## -->
        <!-- section right -->
        <!-- ############## -->
        <secction class="container_instruction_desktop__section_right">
            <article class="container_instruction_desktop__section_right__article">
                <aside class="container_instruction_desktop__section_right__article__aside_top">
                    <div class="container_instruction_desktop__section_right__article__aside_top__div">
                        <h1 class="container_instruction_desktop__section_right__article__aside_top__div__h1">
                            Tarifs
                        </h1>
                    </div>
                </aside>
                <!--  -->
                <aside class="container_instruction_desktop__section_right__article__aside_middle">
                    <!-- div text -->
                    <div class="container_instruction_desktop__section_right__article__aside_middle__div_text">
                        <p class="container_instruction_desktop__section_right__article__aside_middle__div_text__p_top">
                            - Instruction 80 €/jour <br>
                            - Prêt arme = 500€ par jour<br>
                        </p>
                        <!-- prix -->
                        <p class="container_instruction_desktop__section_right__article__aside_middle__div_text__p_bottom">
                            <!-- Prix total : 1 700 € -->
                        </p>
                    </div>
                </aside>
                <!-- aside bottom button -->
                <aside class="container_instruction_desktop__section_right__article__aside_bottom">
                    <div class="container_instruction_desktop__section_right__article__aside_bottom__div_left">
                        <router-link
                            class="container_instruction_desktop__section_right__article__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_instruction_desktop__section_right__article__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                    <div class="container_instruction_desktop__section_right__article__aside_bottom__div_right">
                        <button onclick="document.getElementById('id01').style.display='block'"
                            class="container_instruction_desktop__section_right__article__aside_bottom__div_right__button">
                            <div
                                class="container_instruction_desktop__section_right__article__aside_bottom__div_right__button__div_1">

                            </div>
                            <!--  -->
                            <div
                                class="container_instruction_desktop__section_right__article__aside_bottom__div_right__button__div_2">

                            </div>
                        </button>
                    </div>
                </aside>
            </article>
        </secction>
    </main>
</template>

<script >
export default {
    name: 'InstructionDesktop',
}
</script>

<style  lang=scss>
@import "@/style/components/Services/Instruction/InstructionDesktop.scss";

@media screen and(max-width: 926px) {
    #instruction_desktop {
        display: none;
    }
}
</style>